var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:("inline-block spinner ease-linear\nrounded-full border-2 border-t-2\nborder-" + _vm.color + " h-" + _vm.size + " w-" + _vm.size)})}
var staticRenderFns = []

export { render, staticRenderFns }